"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
function default_1({ roomId, cardType, deleteCommissionFn, deleteStoryFn, }) {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const openMenu = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const closeMenu = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const isRoomCard = cardType === 'room';
    const isCommissionCard = cardType === 'commission';
    const isStoryCard = cardType === 'story';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: {
                    position: 'absolute',
                    top: '6px',
                    right: '6px',
                    width: '24px',
                    height: '24px',
                    backgroundColor: 'rgba(255, 255, 255, 0.6) !important',
                    backdropFilter: 'blur(2px)',
                }, "aria-controls": open ? 'story_setting' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: openMenu }, { children: (0, jsx_runtime_1.jsx)(svgs_1.MoreVertSvg, { css: { width: '16px', height: '16px' } }) })), (0, jsx_runtime_1.jsxs)(Menu_1.default, Object.assign({ id: "story_setting", anchorEl: anchorEl, autoFocus: false, open: open, onClose: closeMenu, onClick: closeMenu, PaperProps: {
                    elevation: 0,
                    sx: {
                        borderRadius: '12px',
                        mt: '4px',
                        boxShadow: '0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)',
                        overflow: 'visible',
                    },
                }, MenuListProps: {
                    sx: {
                        p: 0,
                        '.MuiMenuItem-root': {
                            width: '200px',
                            minHeight: '52px',
                            p: '8px 12px 8px 16px',
                            whiteSpace: 'normal',
                            wordBreak: 'keep-all',
                            lineHeight: 1.2,
                            fontSize: '17px',
                        },
                    },
                }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: [isRoomCard && ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ onClick: () => (window.location.href = `/room/room_edit/?room_id=${roomId}`), sx: { borderRadius: '12px' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.SettingIconSvg, { css: { width: '24px', height: '24px', marginRight: '8px' } }), t('폼 수정')] }))), isCommissionCard && ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ onClick: () => (window.location.href = `/room/commission-update/${roomId}`), sx: { borderRadius: '12px 12px 0 0' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.SettingIconSvg, { css: { width: '24px', height: '24px', marginRight: '8px' } }), t('커미션 수정')] }))), isCommissionCard && ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ onClick: deleteCommissionFn, sx: { borderRadius: '0 0 12px 12px', color: '#EB5757' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.TrashIconRedSvg, { css: { width: '24px', height: '24px', marginRight: '8px' } }), t('커미션 삭제')] }))), isStoryCard && ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ onClick: () => (window.location.href = `/plays/story-update/${roomId}`), sx: { borderRadius: '12px 12px 0 0' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.SettingIconSvg, { css: { width: '24px', height: '24px', marginRight: '8px' } }), t('스토리 수정')] }))), isStoryCard && ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ onClick: deleteStoryFn, sx: { borderRadius: '0 0 12px 12px', color: '#EB5757' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.TrashIconRedSvg, { css: { width: '24px', height: '24px', marginRight: 8 } }), t('스토리 삭제')] })))] }))] }));
}
exports.default = default_1;
